import React, { useState, useEffect } from 'react';

const RecipeDocumentation = (props) => {
  const { queryId } = props;
  const [url, setUrl] = useState(undefined);

  const urlList = [
    {
      uuid: '1950bebe-0757-407c-be99-cb160880e26f',
      url: 'https://help.silentpush.com/docs/search-for-certs-on-a-domain',
    },
    {
      uuid: '6e2f1cff-f5fa-4ff3-9b83-b5b549494d83',
      url: 'https://help.silentpush.com/docs/get-domain-cousins',
    },
    {
      uuid: 'e658d2ef-9e81-48a7-9cf2-dfc25103c081',
      url:
        'https://help.silentpush.com/docs/obtain-basic-information-for-a-domain',
    },
    {
      uuid: '6cb23b71-a36e-4366-8487-fbc52cda47e3',
      url:
        'https://help.silentpush.com/docs/obtain-basic-information-for-a-domain',
    },
    {
      uuid: 'd63324a7-383a-44b5-b340-6633d3e17f12',
      url: 'https://help.silentpush.com/docs/obtain-domain-infratag',
    },
    {
      uuid: '8628aba1-5e81-485e-afeb-45dbfbd7f3ef',
      url: 'https://help.silentpush.com/docs/obtain-domain-infratag',
    },
    {
      uuid: '19eabdf7-eeeb-43e8-b110-8fd96fe2fbdb',
      url: 'https://help.silentpush.com/docs/scan-for-nameserver-changes',
    },
    {
      uuid: 'ada8d7ed-5b61-4a33-b802-2bb0f0453b62',
      url:
        'https://help.silentpush.com/docs/obtain-a-nameservers-reputation-score',
    },
    {
      uuid: 'b011b94e-3804-41d6-844e-02d12b4c424c',
      url:
        'https://help.silentpush.com/docs/obtain-a-silent-push-risk-score-for-a-domain',
    },
    {
      uuid: '17c18b44-213f-465f-9dab-32046764f42a',
      url:
        'https://help.silentpush.com/docs/obtain-a-silent-push-risk-score-for-a-domain',
    },
    {
      uuid: '8d1aa841-bfa1-4160-a809-9d1063c8a0ef',
      url: 'https://help.silentpush.com/docs/advanced-domain-search',
    },
    {
      uuid: '337b7828-3adf-484d-a3ea-f9950755ca16',
      url: 'https://help.silentpush.com/docs/search-for-nameserver-changes',
    },
    {
      uuid: 'e516fde3-3489-450c-ab24-6aeb65de69a2',
      url: 'https://help.silentpush.com/docs/scan-for-domain-siblings',
    },
    {
      uuid: 'b8a0b139-587f-49a8-88da-36e3b0c9c740',
      url:
        'https://help.silentpush.com/docs/get-summarised-information-for-a-domain',
    },
    {
      uuid: '86a5623b-25fc-46f6-ab35-e09118652947',
      url:
        'https://help.silentpush.com/docs/obtain-historic-domain-whois-information',
    },
    {
      uuid: '4d130c76-5b2b-488d-9773-93edfb1e84cb',
      url:
        'https://help.silentpush.com/docs/obtain-live-whos-data-for-a-given-domain',
    },
    {
      uuid: '18c0a933-f4ca-46ca-a303-fa0a0c9f2d40',
      url:
        'https://help.silentpush.com/docs/obtain-enrichment-data-for-a-given-domain',
    },
    {
      uuid: '97e1c147-725a-452d-8752-07d85108a56f',
      url:
        'https://help.silentpush.com/docs/obtain-enriched-data-for-an-ipv4-address',
    },
    {
      uuid: '0f10dda0-0411-41e2-b2de-235f0d4bddbf',
      url:
        'https://help.silentpush.com/docs/obtain-enriched-data-for-an-ipv6-address',
    },
    {
      uuid: 'bae9c9e8-d552-4130-afe0-e7399d8225c6',
      url:
        'https://help.silentpush.com/docs/get-asn-information-for-a-list-of-ipv4-addresses',
    },
    {
      uuid: 'f716de2f-7643-49ce-9704-16f0eb263f1d',
      url:
        'https://help.silentpush.com/docs/obtain-basic-information-about-an-ip-address',
    },
    {
      uuid: '9b617391-fd51-4e6b-92b9-95373b271f91',
      url:
        'https://help.silentpush.com/docs/obtain-basic-information-about-an-ip-address',
    },
    {
      uuid: '58e98120-f759-40cc-b98e-a42cd8b528b6',
      url:
        'https://help.silentpush.com/docs/get-the-silent-push-risk-score-for-a-specific-ip-address',
    },
    {
      uuid: 'b7745001-b05b-4105-aad2-19f26ad940bb',
      url:
        'https://help.silentpush.com/docs/get-the-silent-push-risk-score-for-a-specific-ip-address',
    },
    {
      uuid: 'cf2c717a-ebd4-44be-87ab-5028a52dd78d',
      url:
        'https://help.silentpush.com/docs/get-certificate-information-relating-to-an-ip-address',
    },
    {
      uuid: '142ef207-aee7-493a-a1b5-a39c9e2c8953',
      url: 'https://help.silentpush.com/docs/favicon-searches',
    },
    {
      uuid: '77cbcf8a-774f-4f43-b17c-6b68b19c3d58',
      url:
        'https://help.silentpush.com/docs/get-information-relating-to-a-http-header',
    },
    {
      uuid: '4c97164c-d243-4fbb-89b1-cc76fc9c5ae6',
      url: 'https://help.silentpush.com/docs/scan-for-jarm-data',
    },
    {
      uuid: '65d60b09-5f75-4153-b444-802eed7b91ad',
      url: 'https://help.silentpush.com/docs/search-for-open-directories',
    },
    {
      uuid: '00f74271-718e-40db-81d5-8b0c07fd0bee',
      url:
        'https://help.silentpush.com/docs/get-basic-enrichment-information-for-an-ip-address',
    },
    {
      uuid: '9e60c97e-1eab-469d-93a6-01102c725965',
      url:
        'https://help.silentpush.com/docs/get-basic-information-relating-to-an-ipv6-address',
    },
    {
      uuid: 'e489f576-5d5d-40a7-ae09-a5b3cff99f4c',
      url:
        'https://help.silentpush.com/docs/get-basic-information-relating-to-an-ipv6-address',
    },
    {
      uuid: '89ca70f3-364e-4aba-aae0-5f24efa0675c',
      url:
        'https://help.silentpush.com/docs/get-the-silent-push-risk-score-for-a-specific-ipv6-address',
    },
    {
      uuid: 'a204bb48-7547-489b-b994-566139601837',
      url:
        'https://help.silentpush.com/docs/get-the-silent-push-risk-score-for-a-specific-ipv6-address',
    },
    {
      uuid: '2da02a84-1e01-4e19-b1e5-e615ab19f73b',
      url:
        'https://help.silentpush.com/docs/get-asns-that-have-been-used-by-a-records-for-a-domain-within-the-last-30-days',
    },
    {
      uuid: '71564dfd-d52a-4cf1-aab4-c7483af04ff6',
      url:
        'https://help.silentpush.com/docs/get-information-on-the-number-of-ips-pointed-to-over-time',
    },
    {
      uuid: '370338a9-7485-40ef-9a43-508236e2306b',
      url:
        'https://help.silentpush.com/docs/perform-a-forward-lookup-of-passive-dns-data',
    },
    {
      uuid: '7f6a57ee-3961-452c-9377-6a9156c016ea',
      url: 'https://help.silentpush.com/docs/establish-the-number-of-domains',
    },
    {
      uuid: 'ed2b8d10-23a1-4034-8f16-40331df5c56f',
      url:
        'https://help.silentpush.com/docs/search-through-passive-dns-data-reverse-lookup',
    },
    {
      uuid: 'ed35069b-850b-4c1d-ba07-d690611c3947',
      url:
        'https://help.silentpush.com/docs/search-for-patterns-in-ip-diversity-data',
    },
    {
      uuid: '86f77478-dcad-4452-9c6f-db70bd229c14',
      url: 'https://help.silentpush.com/docs/search-for-self-hosted-domains',
    },
    {
      uuid: 'a55cf850-212f-457f-bcb6-e54ddf7ecce5',
      url: 'https://help.silentpush.com/docs/scan-for-soa-records',
    },
    {
      uuid: '93411044-30c8-4c75-928e-250e665c534c',
      url:
        'https://help.silentpush.com/docs/translate-hash-values-to-server-names',
    },
    {
      uuid: '8da47085-6210-4fd7-a6e4-4d217bdc129a',
      url: 'https://help.silentpush.com/docs/obtain-an-asns-reputation-score',
    },
    {
      uuid: 'ff257fe8-57c6-450a-aa83-d96c168db9d3',
      url:
        'https://help.silentpush.com/docs/obtain-an-asns-takedown-reputation',
    },
    {
      uuid: 'a0f53a53-b6db-4f83-9dfe-8148603c3d00',
      url: 'https://help.silentpush.com/docs/obtain-an-ipv4s-reputation-score',
    },
    {
      uuid: '0f93d648-662d-4929-84a4-3701776d622a',
      url:
        'https://help.silentpush.com/docs/obtain-a-nameserver-reputation-score',
    },
    {
      uuid: '59f1544f-f638-4ca7-b02b-d9f1bf787659',
      url:
        'https://help.silentpush.com/docs/obtain-a-subnet-reputational-score',
    },
    {
      uuid: '761dbf16-c807-4571-bd9b-9cf1fb19b38f',
      url:
        'https://help.silentpush.com/docs/obtain-historic-whois-data-for-a-domain',
    },
    {
      uuid: '8b10c9da-3980-40c4-8db5-96dc36d74c72',
      url:
        'https://help.silentpush.com/docs/get-a-list-of-up-to-date-dns-records-for-a-domain',
    },
    {
      uuid: '5dc8466c-5df9-411f-a4b5-ec6565d962e0',
      url:
        'https://help.silentpush.com/docs/view-recent-attempts-to-resolve-nameserver-records-for-a-domain',
    },
    {
      uuid: 'dc5dab3c-5bae-4ce6-a653-348ef45d8400',
      url:
        'https://help.silentpush.com/docs/scan-padns-data-for-dangling-dns-records',
    },
    {
      uuid: 'fb313606-7ab5-4966-b90b-ed175eee2d9d',
      url:
        'https://help.silentpush.com/docs/establish-when-a-dns-record-was-resolvable',
    },
    {
      uuid: 'ea97a2de-4f6e-4673-a986-2c367f97a713',
      url:
        'https://help.silentpush.com/docs/search-padns-records-for-dangling-dns-entries',
    },
    {
      uuid: 'ca41cd4a-168e-4da3-af5a-3f5706e06713',
      url: 'https://help.silentpush.com/docs/run-a-live-rdap-whois-query',
    },
  ];

  useEffect(() => {
    setUrl(urlList.filter((l) => l.uuid === queryId)[0]?.url);
  }, [queryId]);

  if (url) {
    return (
      <a href={url} target="_blank" role="link">
        Knowledge Base
      </a>
    );
  } else {
    return null;
  }
};

export default RecipeDocumentation;
